import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { getPolicyRuleItems } from './helpers'
import * as Styles from './styles'

const PolicyRuleConfiguration = ({ exception, handleChange, policyRulesData, loading }) => {
  const { t } = useTranslation()

  const menuItems = getPolicyRuleItems(policyRulesData)

  const handleChangePolicyRule = e => {
    handleChange('policy_rule_id', e.target.value)
  }

  return (
    <Styles.SectionContainer>
      <Text type="titleS">{t('Excepciones para reglas condicionales')}</Text>
      <Text type="bodyMRegular">
        {t('Selecciona la regla condicional que no debe aplicarse al pedido, aunque cumpla sus condiciones:')}
      </Text>
      <ComboBox
        label={t('Regla condicional')}
        menuItems={menuItems}
        value={exception?.policy_rule_id}
        handleChange={handleChangePolicyRule}
        loading={loading}
        fullWidth
      />
    </Styles.SectionContainer>
  )
}

export default PolicyRuleConfiguration
